<template>
  <div>
    <vx-card title="Tambah Data" subtitle="Isi data dengan benar">
      <template slot="actions">
        <div class="vx-row">
          <div class="vx-col w-full m-0">
            <vs-button icon-pack="feather" class="mt-2" @click="confirmSave()"
              >Simpan Data</vs-button
            >
            <vs-button
              @click="$router.push({ name: 'cash-book-cashflows', params: { cashbookType: $route.params.cashbookType, cashbookId: $route.params.cashbookId } })"
              class="ml-4 mt-2"
              type="border"
              color="danger"
              >Batal</vs-button
            >
          </div>
        </div>
      </template>
      <div slot="no-body" class="p-6">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
          <!-- <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="w-full mt-4">
                  <label class="text-sm opacity-75">Nomor</label>
                  <vs-row>
                    <vs-col class="px-1 w-full md:w-10/12">
                      <vs-input
                        class="w-full"
                        v-model="number"
                        name="number"
                        type="number"
                        :disabled="!active"
                      />
                    </vs-col>
                    <vs-col class="px-1 my-auto" vs-sm="12" vs-lg="2">
                      <vs-switch v-model="active" />
                    </vs-col>
                  </vs-row>
                </div>
              </div>
            </div> -->
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="w-full mt-4">
                  <label class="text-sm opacity-75">Jenis Kas</label>
                  <ul class="centerx vx-row">
                    <li class="m-3">
                      <vs-radio vs-value="debit" v-model="type"
                        >Kas Masuk</vs-radio
                      >
                    </li>
                    <li class="m-3">
                      <vs-radio vs-value="credit" v-model="type"
                        >Kas Keluar</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="w-full mt-4">
                  <label class="text-sm opacity-75">Tanggal</label>
                  <vs-input
                    class="w-full"
                    type="date"
                    v-mask="'####-##-##'"
                    v-model="date"
                    v-validate="'required'"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('date')"
                    >{{ errors.first("date") }}</span
                  >
                </div>
              </div>
              <!-- <div class="vx-col md:w-1/2 w-full">
              <vs-input class="w-full mt-4" label="Nomor" v-model="number" v-validate="'required|numeric'" name="number" />
              <span class="text-danger text-sm"  v-show="errors.has('number')">{{ errors.first('number') }}</span>
            </div> -->
            </div>

            <div class="vx-row mt-2">
              <div class="vx-col w-full">
                <label class="text-sm opacity-75">Dibayarkan kepada</label>
                <vs-input
                  class="w-full"
                  v-model="paidTo"
                  v-validate="'required'"
                  name="paidTo"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('paidTo')"
                  >{{ errors.first("paidTo") }}</span
                >
              </div>
            </div>

            <div class="vx-row mt-2">
              <div class="vx-col w-full">
                <label class="text-sm opacity-75">Catatan</label>
                <vs-textarea
                  class="w-full"
                  v-model="notes"
                  v-validate="'required'"
                  name="notes"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('notes')"
                  >{{ errors.first("notes") }}</span
                >
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vs-row class="mt-4">
              <vs-col class="px-1" vs-sm="12" vs-lg="7">
                <label class="text-sm opacity-75">Keterangan</label>
              </vs-col>
              <vs-col vs-sm="12" vs-lg="5">
                <vs-row>
                  <vs-col class="px-1" vs-sm="12" vs-lg="10">
                    <label class="text-sm opacity-75">Biaya</label>
                  </vs-col>
                  <vs-col class="px-1" vs-sm="12" vs-lg="2"> &nbsp; </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
            <template>
              <vs-row class="mb-2" v-for="(input, i) in inputs" :key="i">
                <vs-col class="px-1" vs-sm="12" vs-lg="7">
                  <vs-input
                    class="w-full"
                    v-model="input.title"
                    name="input.title"
                    placeholder="Write here"
                  />
                </vs-col>
                <vs-col vs-sm="12" vs-lg="5">
                  <vs-row>
                    <vs-col class="px-1 w-full md:w-10/12">
                      <vs-input
                        class="w-full"
                        v-model="input.amount"
                        name="input.amount"
                        type="number"
                        min="0"
                        v-on:change="amountChange(i)"
                        />
                    </vs-col>
                    <vs-col class="px-1" vs-sm="12" vs-lg="2">
                      <vs-button
                        class="w-full"
                        color="danger"
                        type="filled"
                        v-if="inputs.length > 1"
                        icon-pack="feather"
                        icon="icon-trash"
                        @click="remove(i)"
                      ></vs-button>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
            </template>
            <div class="mt-4 px-1">
              <vs-button
                class="w-full"
                color="success"
                type="filled"
                icon-pack="feather"
                icon="icon-plus"
                @click="add()"
                >Tambah</vs-button
              >
            </div>
            <div class="mt-4 px-1">Total : Rp. {{ amount.toLocaleString() }}</div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import { VMoney } from "v-money";

// Store Module
import moduleCashFlow from "@/store/cashflows/moduleCashFlow.js";

export default {
  components: {
    vSelect,
    Datepicker,
  },
  directives: { money: VMoney },
  data() {
    return {
      type: null,
      paidTo: null,
      date: '',
      debit: null,
      credit: null,
      amount: 0,
      notes: null,
      inputs: [
        {
          title: '',
          amount: 0,
        },
      ],
      number: '',
      active: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: true /* doesn't work with directive */,
      },
    };
  },
  created() {
    if (!moduleCashFlow.isRegistered) {
      this.$store.registerModule("cashFlow", moduleCashFlow);
      moduleCashFlow.isRegistered = true;
    }
  },
  watch: {
    inputs: {
      handler(inputs) {
        this.amount = inputs
          .filter((input) => input.amount)
          .map((input) => parseInt(input.amount.toString().replaceAll(".", "")))
          .reduce((prev, curr) => (prev += curr));
      },
      deep: true,
    },
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.type !== "" &&
        this.paidTo !== "" &&
        this.date !== "" &&
        this.amount !== null
      );
    },
  },
  methods: {
    add() {
      this.inputs.push({
        title: null,
        amount: "0",
      });
    },
    amountChange(index) {
        
        function processNumber(inputString) {
          // Remove leading zeros
          let trimmedString = inputString.replace(/^0+/, '');

          // Convert the string to a number
          let resultNumber = parseInt(trimmedString, 10);

          // Ensure the result is greater than 1
          resultNumber = Math.max(resultNumber, 1);

          return resultNumber;
        }
        const splitamount = this.inputs[index].amount.split("")

        if (splitamount[0] == "0") {
          this.inputs[index].amount = processNumber(this.inputs[index].amount)
        }

        if (this.inputs[index].amount == null || this.inputs[index].amount == "") {
          this.inputs[index].amount = "0"
        }


    },
    remove(index) {
      this.inputs.splice(index, 1);
    },
    confirmSave() {
      if (this.active) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Perhatian',
          text: `Apakah Anda yakin ingin mengindeks ulang buku kas dari tanggal ${this.date} ?`,
          acceptText: 'Yakin',
          accept: this.saveCashFlow
        })
      } else {
        this.saveCashFlow()
      }
    },
    saveCashFlow() {
      const self = this;
      const userData = this.$store.state.AppActiveUser;
      const cashbookId = this.$route.params.cashbookId;

      this.$validator.validateAll().then((result) => {
        if (result) {

          let debit = 0;
          let credit = 0;

          if (self.type === "debit") {
            debit = self.amount;
            credit = 0;
          } else {
            debit = 0;
            credit = self.amount;
          }

          const formData = new FormData();
          formData.set("cashbook_id", cashbookId);
          // formData.set("company_id", userData.company.id);
          // formData.set("employee_id", userData.employee.id);
          formData.set("type", self.type);
          formData.set("paid_to", self.paidTo);
          formData.set("date", self.date);
          if (this.active) {
            formData.append("number", self.number);
          }
          formData.set("debit", debit);
          formData.set("credit", credit);
          formData.set("notes", self.notes);
          formData.append(
            "items",
            JSON.stringify(
              self.inputs.map((input) => {
                input.amount = input.amount.toString().replaceAll(".", "");
                return input;
              })
            )
          );

          this.$store.dispatch("cashFlow/createCashFlow", formData)
          .then(function () {
            self.$vs.notify({
              color: "success",
              title: "Berhasil",
              text: "Buku Kas berhasil di tambahkan",
            });
            self.$router.push({ name: 'cash-book-cashflows', params: { cashbookType: self.$route.params.cashbookType, cashbookId: self.$route.params.cashbookId } });
          })
          .catch((err) => {
            self.$vs.notify({
              color: "danger",
              title: "Opps..",
              text: err,
            });
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.divider {
  background: #e0e0e0;
  height: 1px;
}
</style>
